import { applySnapshot, flow, types } from "mobx-state-tree";

import api from "services/api";

const Context = types.model({
  page: types.number,
  size: types.number,
  pages: types.number,
  totalRows: types.number,
});

const User = types.model({
  id: types.number,
  name: types.string,
  email: types.string,
  isSubscriptionActive: types.boolean,
});

const UsersStore = types
  .model({
    context: types.maybe(Context),
    items: types.array(User),
    isLoading: types.optional(types.boolean, false),
    isSearching: types.optional(types.boolean, false),
    isManaging: types.optional(types.boolean, false),
  })
  .views(self => ({
    get userFoundedByEmail() {
      if (self.items.length === 1) {
        return self.items[0];
      }
      return null;
    },
  }))
  .actions(self => ({
    search: flow(function*(data: string) {
      self.isSearching = true;

      try {
        const payload = { Search: data };
        const { context, items } = yield api.get(`/users/list`, payload);
        applySnapshot(self, { ...self, context, items });
      } catch (error) {
        console.log("error :>> ", error);
        throw error;
      } finally {
        self.isSearching = false;
      }
    }),

    resetPassword: flow(function*(email: string) {
      self.isManaging = true;

      try {
        const payload = { email };
        yield api.post(`/account/change-password`, payload);
      } catch (error) {
        console.log("error :>> ", error);
        throw error;
      } finally {
        self.isManaging = false;
      }
    }),

    reset() {
      applySnapshot(self, { items: [] });
    },
  }));

export default UsersStore.create();
